<template>
    <div class="container" style="padding: 60px 0px">
        <b-row>
            <b-col cols="12">
                <b-link to="/" class="brand-logo"
                    ><img
                        src="data:image/png;base64,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"
                        alt="logo"
                        class=""
                        style="max-width: 150px"
                    /> </b-link
            ></b-col>
        </b-row>
        <b-card :class="className" class="mt-5">
            <b-row>
                <b-col cols="12"
                    ><h4 class="text-success font-weight-bold">
                        Enter the service information to be quoted
                    </h4></b-col
                >
                <b-col cols="12"
                    ><small
                        >Please provide complete and accurate information so
                        that the supplier can quote the best price</small
                    ></b-col
                >
            </b-row>
            <b-row v-if="request_quotation.status_id == 10">
                <b-col cols="12">
                    <b-form-group>
                        <label>Cancellation reasons</label>
                        <b-form-textarea
                            :disabled="readonly"
                            v-model="request_quotation.cancel_reason"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <validation-observer name="Customer" ref="bcRules">
                <b-row
                    v-if="
                        !isCustomer &&
                        (step == 'booking' ||
                            (step == 'created-quotation' &&
                                step != 'view-created-quotation'))
                    "
                >
                    <b-col cols="12" class="pt-1">
                        <validation-provider
                            name="Company"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group>
                                <Select4
                                    v-model="request_quotation.company_id"
                                    :disabled="readonly"
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                    placeholder="Select Company"
                                    @select="
                                        () => {
                                            request_quotation.customer_id = '';
                                        }
                                    "
                                    :options="{
                                        isSearch:true,
                                        value: 'code',
                                        label: 'text',
                                        data: company_list,
                                        fields: [
                                            {
                                                field: 'code',
                                                label: 'Tax Code',
                                            },

                                            { field: 'name', label: 'Name' },
                                            {
                                                field: 'acronym',
                                                label: 'Acronym',
                                            },
                                        ],
                                    }"
                                />
                                <small
                                    class="text-danger"
                                    v-show="errors.length > 0"
                                    >{{ errors[0] }}</small
                                >
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col cols="12" class="pt-1">
                        <validation-provider
                            name="Customer"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group>
                                <Select2
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                    :disabled="
                                        readonly ||
                                        !request_quotation.company_id
                                    "
                                    placeholder="Select Customer"
                                    v-model="request_quotation.customer_id"
                                    :options="customer_list_options"
                                />
                                <small
                                    class="text-danger"
                                    v-show="errors.length > 0"
                                    >{{ errors[0] }}</small
                                >
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                </b-row>

                <b-row class="pt-1">
                    <b-col cols="12">
                        <validation-provider
                            name="Service Type"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group>
                                <Select2
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                    :disabled="readonly || readonlyService"
                                    placeholder="Select Service Type"
                                    v-model="request_quotation.service_type"
                                    :options="service_types"
                                />
                                <small
                                    class="text-danger"
                                    v-show="errors.length > 0"
                                    >{{ errors[0] }}</small
                                >
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                </b-row>
            </validation-observer>
            <validation-observer
                v-if="
                    request_quotation.service_type != null ||
                    view_RequestQuotation != null
                "
                ref="requestQuotationRules"
            >
                <!--FCL-->
                <div v-if="request_quotation.service_type == 2">
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Freight Informations</h4>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="POL"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label>POL<font class="red">*</font></label>
                                    <div class="d-flex">
                                        <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="AOL/POL"
                      select="code"
                      name="code"
                      class="w-100"
                      id="code"
                      v-model="request_quotation.pol_port"
                      :options="ports"
                    /> -->
                                        <Select4
                                            v-model="request_quotation.pol_port"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            placeholder="AOL/POL"
                                            :disabled="readonly"
                                            :options="{
                                                value: 'code',
                                                label: 'name',
                                                data: ports,
                                                fields: [
                                                    {
                                                        field: 'code',
                                                        label: 'Code',
                                                    },
                                                    {
                                                        field: 'name',
                                                        label: 'Name',
                                                    },
                                                    {
                                                        field: 'type',
                                                        label: 'Service',
                                                    },

                                                    {
                                                        field: 'country_code',
                                                        label: 'Country Code',
                                                    },
                                                ],
                                            }"
                                        />
                                        <!-- <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      :disabled="readonly"
                      @click.once="getDataPolPod"
                      v-b-tooltip.hover
                      v-if="!isCustomer"
                      title="Data synchronization with FAST"
                      :key="buttonKey"
                      class="btn-icon ml-1"
                    >
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                                    </div>

                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="POD"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label>POD<font class="red">*</font></label>
                                    <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="AOD/POD"
                    v-model="request_quotation.pod_port"
                    :options="ports"
                  /> -->
                                    <Select4
                                        v-model="request_quotation.pod_port"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        placeholder="AOD/POD"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'code',
                                            label: 'name',
                                            data: ports,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Name',
                                                },
                                                {
                                                    field: 'type',
                                                    label: 'Service',
                                                },
                                                {
                                                    field: 'country_code',
                                                    label: 'Country Code',
                                                },
                                            ],
                                        }"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col cols="12" :lg="4">
                            <validation-provider
                                name="From"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Cargo ready<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.cargo_ready"
                                        type="datetime"
                                        class="w-full"
                                        value-type="format"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 6
                                    : 4
                            "
                        >
                            <validation-provider
                                name="Payment Terms"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Payment Terms</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Payment Terms"
                                        v-model="request_quotation.paymentTerms"
                                        :options="$Options.paymentTerms"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!--  Carrier -->

                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 6
                                    : 4
                            "
                        >
                            <validation-provider
                                name="Carrier"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Carrier</label>
                                    <Select4
                                        v-model="
                                            request_quotation.shipping_line
                                        "
                                        :class="[
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null,
                                            readonly == true ? 'remove' : '',
                                        ]"
                                        placeholder="Carrier"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'id',
                                            label: 'text',
                                            data: shipping_lines,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Shipping Line',
                                                },
                                            ],
                                        }"
                                    />
                                    <small class="text-danger">{{
                                        errors[0]
                                    }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col
                            cols="12"
                            lg="4"
                            v-if="
                                step != 'view-quotation-booking' &&
                                step != 'booking'
                            "
                        >
                            <b-form-group>
                                <label>Volume (Monthly)</label>
                                <!-- <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                /> -->
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.volume"
                                    placeholder="Volume (Monthly)"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="6">
                            <validation-provider
                                name="ETD"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>ETD </label>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.etd"
                                        type="date"
                                        :title="request_quotation.etd"
                                        class="w-full"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        :disabled="readonly"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select date"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY"
                                        @close="handleOpenChange"
                                    >
                                    </date-picker>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="6">
                            <validation-provider
                                name="ETA"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>ETA </label>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.eta"
                                        type="date"
                                        :title="request_quotation.eta"
                                        class="w-full"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        :disabled="readonly"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select date"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY"
                                        @close="handleOpenChange"
                                    >
                                    </date-picker>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Cargo Information</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Commodity"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Commodity<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Commodity"
                                        v-model="request_quotation.goods_type"
                                        :options="goods_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Commodity description"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Commodity description</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.mo_ta"
                                        placeholder="Commodity description"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Gross Weight (kgs)"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Total Gross Weight (kg)</label>
                                    <cleave
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.trong_luong"
                                        class="form-control"
                                        placeholder="Gross Weight (kgs)"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!-- -->
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Shipment Informations</h4>
                        </b-col>
                    </b-row>
                    <b-row v-if="step == 'booking'">
                        <b-col cols="12" md="6">
                            <validation-provider
                                name="BK/HBL/INV"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>BK/HBL/INV </label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.bk_hbl_inv"
                                        placeholder="BK/HBL/INV"
                                    />
                                    <small class="text-danger">{{
                                        errors[0]
                                    }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Shipping Type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Shipping Type"
                                    v-model="request_quotation.shippingType"
                                    :options="
                                        request_quotation.service_type == 5
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : request_quotation.service_type ==
                                              6
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : transport_types.filter((i) =>
                                                  [1, 2].includes(i.id)
                                              )
                                    "
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Container Type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Container Type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Container Type"
                                        v-model="request_quotation.cont_type"
                                        :options="
                                            cont_types.filter(
                                                (i) =>
                                                    i.group ===
                                                    'Container truck'
                                            )
                                        "
                                    />
                                    <!-- <b-form-input
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.cont_type"
                    placeholder="Container Type"
                  /> -->
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Quantity"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Quantity</label>
                                    <b-form-input
                                        type="number"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.so_luong"
                                        placeholder="Quantity"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row v-if="step == 'booking'">
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Container No."
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Container No.</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.container_no"
                                        placeholder="Quantity"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Seal No."
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Seal No.</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.seal"
                                        placeholder="Quantity"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <section v-if="request_quotation.has_container_trucking">
                        <b-row
                            v-if="
                                step == 'created-quotation' ||
                                step == 'view-created-quotation' ||
                                (step == 'view-quotation-booking' &&
                                    (request_quotation.pickup_region != null ||
                                        request_quotation.other_pickup_region) &&
                                    step != 'booking')
                            "
                        >
                            <b-col cols="12" lg="4">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                placeholder="Pick up"
                                                v-model="
                                                    request_quotation.pickup_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                v-model="
                                                    request_quotation.other_pickup_region
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="4">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                placeholder="Delivery"
                                                v-model="
                                                    request_quotation.delivery_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.other_delivery_region
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="4">
                                <b-form-group>
                                    <label>Empty depot</label>
                                    <Select2
                                        :disabled="readonly"
                                        placeholder="Empty depot"
                                        v-model="request_quotation.deport"
                                        :options="regions"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row v-else>
                            <b-col cols="12" lg="4">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.pickup_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Pick up "
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                v-model="
                                                    request_quotation.other_pickup_location
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="4">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.delivery_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Delivery "
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.other_delivery_location
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>

                            <b-col
                                cols="12"
                                lg="4"
                                v-if="
                                    step != 'created-quotation' &&
                                    step != 'view-created-quotation'
                                "
                            >
                                <b-form-group>
                                    <label>Empty depot </label>

                                    <Select4
                                        v-model="
                                            request_quotation.deport_location
                                        "
                                        :key="countRq"
                                        placeholder="Empty depot"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'id',
                                            label: 'text',
                                            data: locations,
                                            fields: [
                                                {
                                                    field: 'abbreviations',
                                                    label: 'Abbreviations',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Location',
                                                },
                                                {
                                                    field: 'address',
                                                    label: 'Address',
                                                },
                                            ],
                                        }"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </section>

                    <b-row> </b-row>
                    <!-- TO DO -->

                    <b-row
                        v-if="
                            request_quotation.has_container_trucking &&
                            (step == 'booking' ||
                                step == 'view-quotation-booking')
                        "
                    >
                        <b-col cols="12" lg="4">
                            <b-form-group>
                                <label>Pick up date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.pick_up_date"
                                        type="datetime"
                                        class="w-full"
                                        :disabled="readonly"
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <b-form-group>
                                <label>Delivery Date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="
                                            request_quotation.delivery_date
                                        "
                                        :disabled-date="disabledRangeDelivery"
                                        type="datetime"
                                        class="w-full"
                                        value-type="format"
                                        :disabled="readonly"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <b-form-group>
                                <label>Cut off Date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.cutOffDate"
                                        type="datetime"
                                        class="w-full"
                                        :disabled="readonly"
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC pick up"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC pick up</label>
                                    <b-form-input
                                        placeholder="PIC pick up"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICPickUp"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC Delivery"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC Delivery</label>
                                    <b-form-input
                                        placeholder="PIC Delivery"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICDelivery"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" lg="4" class="pt-1">
                            <h4>Other service</h4>
                        </b-col>

                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="request_quotation.has_customs"
                                >Customs services
                            </b-form-checkbox>
                        </b-col>
                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="
                                    request_quotation.has_container_trucking
                                "
                                >Container trucking</b-form-checkbox
                            >
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_customs">
                        <b-col cols="12" lg="12" class="pt-1">
                            <h4>Customs declaration information</h4>
                        </b-col>

                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Customs type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Customs type"
                                    v-model="request_quotation.customs_type"
                                    :options="customs_types"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Business type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Business type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Business type"
                                        v-model="
                                            request_quotation.business_type
                                        "
                                        :options="business_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Place of Custom declaration"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Place of Custom declaration</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.customs_addr"
                                        placeholder="Place of Custom declaration"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>HS Code </label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.hs_code"
                                    placeholder="HS Code"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Notes</label>
                                <b-form-textarea
                                    :disabled="readonly"
                                    rows="5"
                                    v-model="request_quotation.notes"
                                    placeholder="Notes"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="
                            (step == 'booking' ||
                                step == 'view-quotation-booking') &&
                            request_quotation.has_container_trucking
                        "
                    >
                        <b-col cols="12">
                            <b-form-group>
                                <label>Billing information</label>
                                <b-form-textarea
                                    :disabled="readonly"
                                    rows="5"
                                    v-model="
                                        request_quotation.billingInformation
                                    "
                                    placeholder="Billing information"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- multi file upload starts -->
                </div>

                <!--LCL service_type = 3 -->
                <div v-if="request_quotation.service_type == 3">
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Freight Informations</h4>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                :name="
                                    request_quotation.service_type == 1
                                        ? 'AOL'
                                        : 'POL'
                                "
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >{{
                                            request_quotation.service_type == 1
                                                ? "AOL"
                                                : "POL"
                                        }}<font class="red">*</font>
                                    </label>
                                    <div class="d-flex">
                                        <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="AOL/POL"
                      class="w-100"
                      v-model="request_quotation.pol_port"
                      :options="ports"
                    /> -->
                                        <Select4
                                            v-model="request_quotation.pol_port"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            placeholder="AOL/POL"
                                            :disabled="readonly"
                                            :options="{
                                                value: 'code',
                                                label: 'name',
                                                data: ports,
                                                fields: [
                                                    {
                                                        field: 'code',
                                                        label: 'Code',
                                                    },
                                                    {
                                                        field: 'name',
                                                        label: 'Name',
                                                    },
                                                    {
                                                        field: 'type',
                                                        label: 'Service',
                                                    },
                                                    {
                                                        field: 'country_code',
                                                        label: 'Country Code',
                                                    },
                                                ],
                                            }"
                                        />
                                        <!-- <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      :disabled="readonly"
                      @click.once="getDataPolPod"
                      v-if="!isCustomer"
                      v-b-tooltip.hover
                      title="Data synchronization with FAST"
                      :key="buttonKey"
                      class="btn-icon ml-1"
                    >
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                                    </div>

                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                :name="
                                    request_quotation.service_type == 1
                                        ? 'AOD'
                                        : 'POD'
                                "
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >{{
                                            request_quotation.service_type == 1
                                                ? "AOD"
                                                : "POD"
                                        }}<font class="red">*</font></label
                                    >

                                    <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="AOD/POL"
                    v-model="request_quotation.pod_port"
                    :options="ports"
                  /> -->

                                    <Select4
                                        v-model="request_quotation.pod_port"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        placeholder="AOD/POL"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'code',
                                            label: 'name',
                                            data: ports,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Name',
                                                },
                                                {
                                                    field: 'type',
                                                    label: 'Service',
                                                },
                                                {
                                                    field: 'country_code',
                                                    label: 'Country Code',
                                                },
                                            ],
                                        }"
                                    />

                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" :lg="4">
                            <validation-provider
                                name="Cargo ready"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Cargo ready<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex">
                                        <date-picker
                                            ref="datePicker"
                                            v-model="
                                                request_quotation.cargo_ready
                                            "
                                            type="datetime"
                                            class="w-full"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            value-type="format"
                                            :disabled="readonly"
                                            title-format="DD/MM/YY"
                                            time-title-format="DD/MM/YY"
                                            placeholder="Select datetime"
                                            :show-time-panel="showTimePanel"
                                            format="DD/MM/YY HH:mm"
                                            @close="handleOpenChange"
                                        >
                                            <template v-slot:footer>
                                                <button
                                                    class="mx-btn mx-btn-text"
                                                    @click="toggleTimePanel"
                                                >
                                                    {{
                                                        showTimePanel
                                                            ? "Date"
                                                            : "Time"
                                                    }}
                                                </button>
                                            </template>
                                        </date-picker>
                                        <!-- <b-button
                      variant="primary"
                      v-if="!readonly"
                      type="button"
                      :disabled="readonly"
                      @click="modalSchedule = !modalSchedule"
                      class="btn ml-50 p-0"
                    >
                      Select schedule
                    </b-button> -->
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 6
                                    : 4
                            "
                        >
                            <validation-provider
                                name="Payment Terms"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Payment Terms</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Payment Terms"
                                        v-model="request_quotation.paymentTerms"
                                        :options="$Options.paymentTerms"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!--  Carrier -->

                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 6
                                    : 4
                            "
                        >
                            <validation-provider
                                name="Carrier"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Carrier</label>
                                    <Select4
                                        v-model="
                                            request_quotation.shipping_line
                                        "
                                        :class="[
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null,
                                            readonly == true ? 'remove' : '',
                                        ]"
                                        placeholder="Carrier"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'id',
                                            label: 'text',
                                            data: shipping_lines,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Shipping Line',
                                                },
                                            ],
                                        }"
                                    />
                                    <small class="text-danger">{{
                                        errors[0]
                                    }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col
                            cols="12"
                            lg="4"
                            v-if="
                                step != 'view-quotation-booking' &&
                                step != 'booking'
                            "
                        >
                            <b-form-group>
                                <label>Volume (Monthly)</label>
                                <!-- <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                /> -->
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.volume"
                                    placeholder="Volume (Monthly)"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="6">
                            <validation-provider
                                name="ETD"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>ETD </label>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.etd"
                                        type="date"
                                        :title="request_quotation.etd"
                                        class="w-full"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        :disabled="readonly"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select date"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY"
                                        @close="handleOpenChange"
                                    >
                                    </date-picker>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="6">
                            <validation-provider
                                name="ETA"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>ETA </label>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.eta"
                                        type="date"
                                        :title="request_quotation.eta"
                                        class="w-full"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        :disabled="readonly"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select date"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY"
                                        @close="handleOpenChange"
                                    >
                                    </date-picker>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Cargo Information</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Commodity"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Commodity<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Commodity"
                                        v-model="request_quotation.goods_type"
                                        :options="goods_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Commodity description"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Commodity description</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.mo_ta"
                                        placeholder="Commodity description"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Gross Weight (kgs)"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Total Gross Weight (kg)</label>
                                    <cleave
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.trong_luong"
                                        class="form-control"
                                        placeholder="Gross Weight (kgs)"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!-- -->
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <b-form-group>
                                <label>Measurement (cbm)</label>
                                <cleave
                                    :options="$Utils.CONSTANTS.cleaveNumeral"
                                    :disabled="readonly"
                                    v-model="request_quotation.so_khoi"
                                    class="form-control"
                                    placeholder="Measurement (kgs)"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Handled type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Handled type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Handled type"
                                        v-model="request_quotation.handled_type"
                                        :options="handed_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Dimension"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Dimension</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.dimension"
                                        placeholder="Dimension"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Package type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package type</label>

                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Package type"
                                        v-model="request_quotation.package_type"
                                        :options="
                                            cont_types.filter(
                                                (i) => i.group === 'packaging'
                                            )
                                        "
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Package Number"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package Number</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="
                                            request_quotation.packageNumber
                                        "
                                        placeholder="Package Number"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_van_trucking">
                        <b-col cols="12" class="pt-1">
                            <h4>Shipment Informations</h4>
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="
                            (step == 'booking' ||
                                step == 'view-quotation-booking') &&
                            request_quotation.has_van_trucking
                        "
                    >
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Booking/HBL/INV</label>
                                <b-form-input
                                    :disabled="readonly"
                                    placeholder="Booking/HBL/INV"
                                    v-model="request_quotation.HBL"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Shipping Type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Shipping Type"
                                    v-model="request_quotation.shippingType"
                                    :options="
                                        request_quotation.service_type == 5
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : request_quotation.service_type ==
                                              6
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : transport_types.filter((i) =>
                                                  [1, 2].includes(i.id)
                                              )
                                    "
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_van_trucking">
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Truck Type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Truck Type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Truck Type"
                                        v-model="request_quotation.truck_type"
                                        :options="
                                            cont_types.filter(
                                                (i) => i.group === 'van truck'
                                            )
                                        "
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Quantity"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Quantity</label>
                                    <b-form-input
                                        placeholder="Quantity"
                                        type="number"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.so_luong"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <section v-if="request_quotation.has_van_trucking">
                        <b-row
                            v-if="
                                step == 'created-quotation' ||
                                step == 'view-created-quotation' ||
                                (step == 'view-quotation-booking' &&
                                    (request_quotation.pickup_region != null ||
                                        request_quotation.other_pickup_region) &&
                                    step != 'booking')
                            "
                        >
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                placeholder="Pick up"
                                                v-model="
                                                    request_quotation.pickup_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_pickup_region
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                placeholder="Delivery"
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.delivery_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.other_delivery_region
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>

                        <b-row v-else>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.pickup_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Pick up "
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                v-model="
                                                    request_quotation.other_pickup_location
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.delivery_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Delivery "
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_delivery_location
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </section>

                    <b-row
                        v-if="
                            request_quotation.has_van_trucking &&
                            (step == 'booking' ||
                                step == 'view-quotation-booking')
                        "
                    >
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Pick up date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.pick_up_date"
                                        type="datetime"
                                        class="w-full"
                                        :disabled="readonly"
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Delivery Date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="
                                            request_quotation.delivery_date
                                        "
                                        :disabled-date="disabledRangeDelivery"
                                        type="datetime"
                                        class="w-full"
                                        value-type="format"
                                        :disabled="readonly"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC pick up"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC pick up</label>
                                    <b-form-input
                                        placeholder="PIC pick up"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICPickUp"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC Delivery"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC Delivery</label>
                                    <b-form-input
                                        placeholder="PIC Delivery"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICDelivery"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.service_type == 1">
                        <b-col cols="12" class="pt-1">
                            <h4>Intended schedule</h4>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="From"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >From<font class="red">*</font></label
                                    >
                                    <b-form-datepicker
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.from_date"
                                        :date-format-options="{
                                            year: 'numeric',
                                            month: 'numeric',
                                            day: 'numeric',
                                        }"
                                        locale="vi-VN"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="To"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label>To<font class="red">*</font></label>
                                    <b-form-datepicker
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.to_date"
                                        :date-format-options="{
                                            year: 'numeric',
                                            month: 'numeric',
                                            day: 'numeric',
                                        }"
                                        locale="vi-VN"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4" class="pt-1">
                            <h4>Other service</h4>
                        </b-col>
                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="request_quotation.has_customs"
                                >Customs services
                            </b-form-checkbox>
                        </b-col>
                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="request_quotation.has_van_trucking"
                                >Van trucking
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_customs">
                        <b-col cols="12" lg="12" class="pt-1">
                            <h4>Customs declaration information</h4>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Customs type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Customs type"
                                    v-model="request_quotation.customs_type"
                                    :options="customs_types"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Business type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Business type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Business type"
                                        v-model="
                                            request_quotation.business_type
                                        "
                                        :options="business_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Place of Custom declaration"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Place of Custom declaration</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.customs_addr"
                                        placeholder="Place of Custom declaration"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>HS Code</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.hs_code"
                                    placeholder="HS Code"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Notes</label>
                                <b-form-textarea
                                    rows="5"
                                    :disabled="readonly"
                                    v-model="request_quotation.notes"
                                    placeholder="Notes"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- multi file upload starts -->
                </div>
                <!-- + Air-->
                <div v-if="request_quotation.service_type == 1">
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Freight Informations</h4>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                :name="
                                    request_quotation.service_type == 1
                                        ? 'AOL'
                                        : 'POL'
                                "
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >{{
                                            request_quotation.service_type == 1
                                                ? "AOL"
                                                : "POL"
                                        }}<font class="red">*</font>
                                    </label>
                                    <div class="d-flex">
                                        <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="AOL/POL"
                      class="w-100"
                      v-model="request_quotation.pol_port"
                      :options="ports"
                    /> -->
                                        <Select4
                                            v-model="request_quotation.pol_port"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            placeholder="AOL/POL"
                                            :disabled="readonly"
                                            :options="{
                                                value: 'code',
                                                label: 'name',
                                                data: ports,
                                                fields: [
                                                    {
                                                        field: 'code',
                                                        label: 'Code',
                                                    },
                                                    {
                                                        field: 'name',
                                                        label: 'Name',
                                                    },
                                                    {
                                                        field: 'type',
                                                        label: 'Service',
                                                    },
                                                    {
                                                        field: 'country_code',
                                                        label: 'Country Code',
                                                    },
                                                ],
                                            }"
                                        />
                                        <!-- <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      :disabled="readonly"
                      @click.once="getDataPolPod"
                      v-if="!isCustomer"
                      v-b-tooltip.hover
                      title="Data synchronization with FAST"
                      :key="buttonKey"
                      class="btn-icon ml-1"
                    >
                      <feather-icon icon="RefreshCwIcon" />
                    </b-button> -->
                                    </div>

                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                :name="
                                    request_quotation.service_type == 1
                                        ? 'AOD'
                                        : 'POD'
                                "
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >{{
                                            request_quotation.service_type == 1
                                                ? "AOD"
                                                : "POD"
                                        }}<font class="red">*</font></label
                                    >

                                    <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="AOD/POL"
                    v-model="request_quotation.pod_port"
                    :options="ports"
                  /> -->
                                    <Select4
                                        v-model="request_quotation.pod_port"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        placeholder="AOD/POL"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'code',
                                            label: 'name',
                                            data: ports,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Name',
                                                },
                                                {
                                                    field: 'type',
                                                    label: 'Service',
                                                },
                                                {
                                                    field: 'country_code',
                                                    label: 'Country Code',
                                                },
                                            ],
                                        }"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" :lg="4">
                            <validation-provider
                                name="Cargo ready"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Cargo ready<font class="red"
                                            >*</font
                                        ></label
                                    >

                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.cargo_ready"
                                        type="datetime"
                                        class="w-full"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        value-type="format"
                                        :disabled="readonly"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>

                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 6
                                    : 4
                            "
                        >
                            <validation-provider
                                name="Payment Terms"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Payment Terms</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Payment Terms"
                                        v-model="request_quotation.paymentTerms"
                                        :options="$Options.paymentTerms"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!--  Carrier -->

                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 6
                                    : 4
                            "
                        >
                            <validation-provider
                                name="Airline"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Airline</label>

                                    <Select4
                                        v-model="
                                            request_quotation.shipping_line
                                        "
                                        :class="[
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null,
                                            readonly == true ? 'remove' : '',
                                        ]"
                                        placeholder="Airline"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'id',
                                            label: 'text',
                                            data: shipping_lines,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Shipping Line',
                                                },
                                            ],
                                        }"
                                    />
                                    <small class="text-danger">{{
                                        errors[0]
                                    }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col
                            cols="12"
                            lg="4"
                            v-if="
                                step != 'view-quotation-booking' &&
                                step != 'booking'
                            "
                        >
                            <b-form-group>
                                <label>Volume (Monthly)</label>
                                <!-- <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                /> -->
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.volume"
                                    placeholder="Volume (Monthly)"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="6">
                            <validation-provider
                                name="ETD"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>ETD </label>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.etd"
                                        type="date"
                                        :title="request_quotation.etd"
                                        class="w-full"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        :disabled="readonly"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select date"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY"
                                        @close="handleOpenChange"
                                    >
                                    </date-picker>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="6">
                            <validation-provider
                                name="ETA"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>ETA </label>
                                    <!-- <b-form-datepicker
                    :state="errors.length > 0 ? false : null"
                    v-model="request_quotation.eta"
                    :disabled="readonly"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  /> -->
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.eta"
                                        type="date"
                                        :title="request_quotation.eta"
                                        class="w-full"
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        :disabled="readonly"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select date"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY"
                                        @close="handleOpenChange"
                                    >
                                    </date-picker>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Cargo Information</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Commodity"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Commodity<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Commodity"
                                        v-model="request_quotation.goods_type"
                                        :options="goods_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Commodity description"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Commodity description</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.mo_ta"
                                        placeholder="Commodity description"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Gross Weight (kgs)"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Total Gross Weight (kg)</label>

                                    <cleave
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.trong_luong"
                                        class="form-control"
                                        placeholder="Gross Weight (kgs)"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!-- -->
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <b-form-group>
                                <label>Measurement (cbm)</label>
                                <cleave
                                    :options="$Utils.CONSTANTS.cleaveNumeral"
                                    :disabled="readonly"
                                    v-model="request_quotation.so_khoi"
                                    class="form-control"
                                    placeholder="Measurement (kgs)"
                                />
                                <!-- <b-form-input
                  type="number"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  placeholder="Measurement (kgs)"
                /> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Handled type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Handled type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Handled type"
                                        v-model="request_quotation.handled_type"
                                        :options="handed_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Total Charge Weight (kg)"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Total Charge Weight (kg)</label>
                                    <cleave
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="true"
                                        v-model="
                                            request_quotation.totalChargeWeight
                                        "
                                        class="form-control"
                                        placeholder="Total Charge Weight (kg)"
                                    />
                                    <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.totalChargeWeight"
                    placeholder="Total Charge Weight (kg)"
                  /> -->
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Package type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package type</label>

                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Package type"
                                        v-model="request_quotation.package_type"
                                        :options="
                                            cont_types.filter(
                                                (i) => i.group === 'packaging'
                                            )
                                        "
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Package Number"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package Number</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="
                                            request_quotation.packageNumber
                                        "
                                        placeholder="Package Number"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_van_trucking">
                        <b-col cols="12" class="pt-1">
                            <h4>Shipment Informations</h4>
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="
                            (step == 'booking' ||
                                step == 'view-quotation-booking') &&
                            request_quotation.has_van_trucking
                        "
                    >
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Booking/HBL/INV</label>
                                <b-form-input
                                    :disabled="readonly"
                                    placeholder="Booking/HBL/INV"
                                    v-model="request_quotation.HBL"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Shipping Type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Shipping Type"
                                    v-model="request_quotation.shippingType"
                                    :options="
                                        request_quotation.service_type == 5
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : request_quotation.service_type ==
                                              6
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : transport_types.filter((i) =>
                                                  [1, 2].includes(i.id)
                                              )
                                    "
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_van_trucking">
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Truck Type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Truck Type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Truck Type"
                                        v-model="request_quotation.truck_type"
                                        :options="
                                            cont_types.filter(
                                                (i) => i.group === 'van truck'
                                            )
                                        "
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Quantity"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Quantity</label>
                                    <cleave
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.so_luong"
                                        class="form-control"
                                        placeholder="Quantity"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <section v-if="request_quotation.has_van_trucking">
                        <b-row
                            v-if="
                                step == 'created-quotation' ||
                                step == 'view-created-quotation' ||
                                (step == 'view-quotation-booking' &&
                                    (request_quotation.pickup_region != null ||
                                        request_quotation.other_pickup_region) &&
                                    step != 'booking')
                            "
                        >
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                placeholder="Pick up"
                                                v-model="
                                                    request_quotation.pickup_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_pickup_region
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                placeholder="Delivery"
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.delivery_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.other_delivery_region
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>

                        <b-row v-else>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.pickup_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Pick up "
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                v-model="
                                                    request_quotation.other_pickup_location
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.delivery_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Delivery "
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_delivery_location
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </section>
                    <b-row
                        v-if="
                            request_quotation.has_van_trucking &&
                            (step == 'booking' ||
                                step == 'view-quotation-booking')
                        "
                    >
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Pick up date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.pick_up_date"
                                        type="datetime"
                                        class="w-full"
                                        :disabled="readonly"
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Delivery Date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="
                                            request_quotation.delivery_date
                                        "
                                        :disabled-date="disabledRangeDelivery"
                                        type="datetime"
                                        class="w-full"
                                        value-type="format"
                                        :disabled="readonly"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC pick up"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC pick up</label>
                                    <b-form-input
                                        placeholder="PIC pick up"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICPickUp"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC Delivery"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC Delivery</label>
                                    <b-form-input
                                        placeholder="PIC Delivery"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICDelivery"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4" class="pt-1">
                            <h4>Other service</h4>
                        </b-col>
                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="request_quotation.has_customs"
                                >Customs services
                            </b-form-checkbox>
                        </b-col>
                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="request_quotation.has_van_trucking"
                                >Van trucking
                            </b-form-checkbox>
                        </b-col>
                    </b-row>

                    <b-row v-if="request_quotation.has_customs">
                        <b-col cols="12" lg="12" class="pt-1">
                            <h4>Customs declaration information</h4>
                        </b-col>

                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Customs type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Customs type"
                                    v-model="request_quotation.customs_type"
                                    :options="customs_types"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Business type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Business type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Business type"
                                        v-model="
                                            request_quotation.business_type
                                        "
                                        :options="business_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Place of Custom declaration"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Place of Custom declaration</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.customs_addr"
                                        placeholder="Place of Custom declaration"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>HS Code</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.hs_code"
                                    placeholder="HS Code"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Notes</label>
                                <b-form-textarea
                                    rows="5"
                                    :disabled="readonly"
                                    v-model="request_quotation.notes"
                                    placeholder="Notes"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- multi file upload starts -->
                </div>

                <!--Container Trucking-->
                <div v-if="request_quotation.service_type == 5">
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Shipment Informations</h4>
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Booking/HBL/INV</label>
                                <b-form-input
                                    :disabled="readonly"
                                    placeholder="Booking/HBL/INV"
                                    v-model="request_quotation.HBL"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Shipping Type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Shipping Type"
                                    v-model="request_quotation.shippingType"
                                    :options="
                                        request_quotation.service_type == 5
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : request_quotation.service_type ==
                                              6
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : transport_types.filter((i) =>
                                                  [1, 2].includes(i.id)
                                              )
                                    "
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <!--  -->
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Container Type"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Container Type
                                        <font class="red">*</font></label
                                    >
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Container Type"
                                        v-model="request_quotation.cont_type"
                                        :options="
                                            cont_types.filter(
                                                (i) =>
                                                    i.group ===
                                                    'Container truck'
                                            )
                                        "
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Quantity"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Quantity</label>
                                    <cleave
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.so_luong"
                                        class="form-control"
                                        placeholder="Quantity"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <b-form-group>
                                <label>Container No.</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.container_no"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <b-form-group>
                                <label>Seal</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.seal_no"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? '6'
                                    : '4'
                            "
                        >
                            <validation-provider
                                name="Pick up"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Pick up<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select2
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            class="hide_select w-100"
                                            v-if="
                                                !request_quotation.isHideShows
                                            "
                                            :disabled="readonly"
                                            placeholder="Pick up"
                                            v-model="
                                                request_quotation.pickup_region
                                            "
                                            :options="regions"
                                        />
                                        <b-form-input
                                            v-if="request_quotation.isHideShows"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.other_pickup_region
                                            "
                                            placeholder="Enter pick up "
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsi"
                                            v-model="
                                                request_quotation.isHideShows
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? '6'
                                    : '4'
                            "
                        >
                            <validation-provider
                                name="Delivery"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Delivery<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select2
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            class="hide_select w-100"
                                            v-if="
                                                !request_quotation.isHideShowPk
                                            "
                                            :disabled="readonly"
                                            placeholder="Delivery"
                                            v-model="
                                                request_quotation.delivery_region
                                            "
                                            :options="regions"
                                        />
                                        <b-form-input
                                            :disabled="readonly"
                                            v-if="
                                                request_quotation.isHideShowPk
                                            "
                                            v-model="
                                                request_quotation.other_delivery_region
                                            "
                                            placeholder="Enter pick up"
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsPk"
                                            v-model="
                                                request_quotation.isHideShowPk
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? '6'
                                    : '4'
                            "
                            v-if="
                                (step != 'created-quotation' &&
                                    step != 'view-created-quotation' &&
                                    step == 'view-quotation-booking' &&
                                    (request_quotation.pickup_location !=
                                        null ||
                                        request_quotation.other_pickup_location !=
                                            null)) ||
                                step == 'booking'
                            "
                        >
                            <validation-provider
                                name="Pick up"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Pick up<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select4
                                            :key="countRq"
                                            v-model="
                                                request_quotation.pickup_location
                                            "
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid hide_select'
                                                    : 'hide_select'
                                            "
                                            :disabled="readonly"
                                            placeholder="Enter Pick up "
                                            v-if="
                                                !request_quotation.isHideShows
                                            "
                                            :options="{
                                                value: 'id',
                                                label: 'text',
                                                data: locations,
                                                fields: [
                                                    {
                                                        field: 'abbreviations',
                                                        label: 'Abbreviations',
                                                    },
                                                    {
                                                        field: 'name',
                                                        label: 'Location',
                                                    },
                                                    {
                                                        field: 'address',
                                                        label: 'Address',
                                                    },
                                                ],
                                            }"
                                        />
                                        <b-form-input
                                            v-if="request_quotation.isHideShows"
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.other_pickup_location
                                            "
                                            placeholder="Enter pick up "
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsi"
                                            v-model="
                                                request_quotation.isHideShows
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? '6'
                                    : '4'
                            "
                            v-if="
                                (step != 'created-quotation' &&
                                    step != 'view-created-quotation' &&
                                    step == 'view-quotation-booking' &&
                                    (request_quotation.delivery_location !=
                                        null ||
                                        request_quotation.other_delivery_location !=
                                            null)) ||
                                step == 'booking'
                            "
                        >
                            <validation-provider
                                name="Delivery"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Delivery<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select4
                                            v-model="
                                                request_quotation.delivery_location
                                            "
                                            :key="countRq"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid hide_select'
                                                    : 'hide_select'
                                            "
                                            placeholder="Enter Delivery "
                                            v-if="
                                                !request_quotation.isHideShowPk
                                            "
                                            :disabled="readonly"
                                            :options="{
                                                value: 'id',
                                                label: 'text',
                                                data: locations,
                                                fields: [
                                                    {
                                                        field: 'abbreviations',
                                                        label: 'Abbreviations',
                                                    },
                                                    {
                                                        field: 'name',
                                                        label: 'Location',
                                                    },
                                                    {
                                                        field: 'address',
                                                        label: 'Address',
                                                    },
                                                ],
                                            }"
                                        />
                                        <b-form-input
                                            :disabled="readonly"
                                            v-if="
                                                request_quotation.isHideShowPk
                                            "
                                            v-model="
                                                request_quotation.other_delivery_location
                                            "
                                            placeholder="Enter pick up"
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsPk"
                                            v-model="
                                                request_quotation.isHideShowPk
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <!--  -->

                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? '6'
                                    : '4'
                            "
                            v-if="
                                (step != 'created-quotation' &&
                                    step != 'view-created-quotation' &&
                                    step == 'view-quotation-booking' &&
                                    request_quotation.deport_location !=
                                        null) ||
                                step == 'booking'
                            "
                        >
                            <b-form-group>
                                <label>Empty depot </label>

                                <Select4
                                    v-model="request_quotation.deport_location"
                                    placeholder="Empty depot"
                                    :disabled="readonly"
                                    :options="{
                                        value: 'id',
                                        label: 'text',
                                        data: locationsNoService,
                                        fields: [
                                            {
                                                field: 'abbreviations',
                                                label: 'Abbreviations',
                                            },
                                            {
                                                field: 'name',
                                                label: 'Location',
                                            },
                                            {
                                                field: 'address',
                                                label: 'Address',
                                            },
                                        ],
                                    }"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? '6'
                                    : '4'
                            "
                            v-else
                        >
                            <b-form-group>
                                <label>Empty depot</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Empty depot"
                                    v-model="request_quotation.deport"
                                    :options="regions"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <b-form-group>
                                <label>Cut off Date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.cutOffDate"
                                        type="datetime"
                                        class="w-full"
                                        :disabled="readonly"
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <b-form-group>
                                <label>Pick up date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.pick_up_date"
                                        type="datetime"
                                        class="w-full"
                                        :disabled="readonly"
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <b-form-group>
                                <label>Delivery Date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="
                                            request_quotation.delivery_date
                                        "
                                        :disabled-date="disabledRangeDelivery"
                                        type="datetime"
                                        class="w-full"
                                        value-type="format"
                                        :disabled="readonly"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <validation-provider
                                name="PIC pick up"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC pick up</label>
                                    <b-form-input
                                        placeholder="PIC pick up"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICPickUp"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <validation-provider
                                name="PIC Delivery"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC Delivery</label>
                                    <b-form-input
                                        placeholder="PIC Delivery"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICDelivery"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 12
                                    : 6
                            "
                        >
                            <b-col
                                :lg="
                                    step == 'booking' ||
                                    step == 'view-quotation-booking'
                                        ? 12
                                        : 6
                                "
                                class="pt-1 pl-0"
                            >
                                <h4>Freight Informations</h4>
                            </b-col>
                            <b-col
                                lg="
                  12
                "
                            >
                                <b-form-group
                                    v-if="
                                        step == 'booking' ||
                                        step == 'view-quotation-booking'
                                    "
                                >
                                    <label>Carriers </label>

                                    <Select4
                                        v-model="
                                            request_quotation.shipping_line
                                        "
                                        placeholder="Carriers"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'id',
                                            label: 'text',
                                            data: shipping_lines,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Shipping Line',
                                                },
                                            ],
                                        }"
                                    />
                                </b-form-group>
                                <b-form-group v-else>
                                    <label>Volume (Monthly)</label>

                                    <b-form-input
                                        :disabled="readonly"
                                        v-model="request_quotation.volume"
                                        placeholder="Volume (Monthly)"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-col>
                        <b-col
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 12
                                    : 6
                            "
                        >
                            <b-col
                                :lg="
                                    step == 'booking' ||
                                    step == 'view-quotation-booking'
                                        ? 12
                                        : 6
                                "
                                class="pt-1 pl-0"
                            >
                                <h4>Cargo Information</h4>
                            </b-col>

                            <b-row>
                                <b-col
                                    :lg="
                                        step == 'booking' ||
                                        step == 'view-quotation-booking'
                                            ? 6
                                            : 12
                                    "
                                >
                                    <validation-provider
                                        name="Commodity"
                                        #default="{ errors }"
                                        rules="required"
                                    >
                                        <b-form-group>
                                            <label
                                                >Commodity<font class="red"
                                                    >*</font
                                                ></label
                                            >
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                :disabled="readonly"
                                                placeholder="Commodity"
                                                v-model="
                                                    request_quotation.goods_type
                                                "
                                                :options="goods_types"
                                            />
                                            <small
                                                class="text-danger"
                                                v-show="errors.length > 0"
                                                >{{ errors[0] }}</small
                                            >
                                        </b-form-group>
                                    </validation-provider>
                                </b-col>
                                <b-col
                                    v-if="
                                        step == 'booking' ||
                                        step == 'view-quotation-booking'
                                    "
                                    cols="12"
                                    lg="6"
                                >
                                    <validation-provider
                                        name="Gross Weight (kgs)"
                                        #default="{ errors }"
                                        rules=""
                                    >
                                        <b-form-group>
                                            <label
                                                >Total Gross Weight (kg)</label
                                            >

                                            <cleave
                                                :state="
                                                    errors.length > 0
                                                        ? false
                                                        : null
                                                "
                                                :options="
                                                    $Utils.CONSTANTS
                                                        .cleaveNumeral
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.trong_luong
                                                "
                                                class="form-control"
                                                placeholder="Gross Weight (kgs)"
                                            />
                                            <small
                                                class="text-danger"
                                                v-show="errors.length > 0"
                                                >{{ errors[0] }}</small
                                            >
                                        </b-form-group>
                                    </validation-provider>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" lg="4" class="pt-1">
                            <h4>Other service</h4>
                        </b-col>
                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="request_quotation.has_customs"
                                >Customs services
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_customs">
                        <b-col lg="12" class="pt-1">
                            <h4>Customs declaration information</h4>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Customs type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Customs type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Customs type"
                                        v-model="request_quotation.customs_type"
                                        :options="customs_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Business type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Business type </label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Business type"
                                        v-model="
                                            request_quotation.business_type
                                        "
                                        :options="business_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Place of Custom declaration"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Place of Custom declaration </label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.customs_addr"
                                        placeholder="Place of Custom declaration"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>HS Code</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.hs_code"
                                    placeholder="HS Code"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Notes</label>
                                <b-form-textarea
                                    :disabled="readonly"
                                    rows="5"
                                    v-model="request_quotation.notes"
                                    placeholder="Notes"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="12">
                            <b-form-group>
                                <label>Billing information</label>
                                <b-form-textarea
                                    :disabled="readonly"
                                    rows="5"
                                    v-model="
                                        request_quotation.billingInformation
                                    "
                                    placeholder="Billing information"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- multi file upload ends -->
                </div>

                <!--Van Trucking-->
                <div v-if="request_quotation.service_type == 6">
                    <b-row>
                        <b-col cols="12" class="pt-1">
                            <h4>Shipment Informations</h4>
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Booking/HBL/INV</label>
                                <b-form-input
                                    :disabled="readonly"
                                    placeholder="Booking/HBL/INV"
                                    v-model="request_quotation.HBL"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Shipping Type</label>
                                <Select2
                                    :disabled="readonly"
                                    placeholder="Shipping Type"
                                    v-model="request_quotation.shippingType"
                                    :options="
                                        request_quotation.service_type == 5
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : request_quotation.service_type ==
                                              6
                                            ? transport_types.filter((i) =>
                                                  [1, 2, 3, 4].includes(i.id)
                                              )
                                            : transport_types.filter((i) =>
                                                  [1, 2].includes(i.id)
                                              )
                                    "
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Truck Type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Truck Type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Truck Type"
                                        v-model="request_quotation.truck_type"
                                        :options="
                                            cont_types.filter(
                                                (i) => i.group === 'van truck'
                                            )
                                        "
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Quantity"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Quantity</label>
                                    <cleave
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.so_luong"
                                        class="form-control"
                                        placeholder="Quantity"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row
                        v-if="
                            step == 'created-quotation' ||
                            step == 'view-created-quotation' ||
                            (step == 'view-quotation-booking' &&
                                (request_quotation.pickup_region != null ||
                                    request_quotation.other_pickup_region) &&
                                step != 'booking')
                        "
                    >
                        <b-col :cols="6">
                            <validation-provider
                                name="Pick up"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Pick up<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select2
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            class="hide_select"
                                            v-if="
                                                !request_quotation.isHideShows
                                            "
                                            :disabled="readonly"
                                            placeholder="Pick up"
                                            v-model="
                                                request_quotation.pickup_region
                                            "
                                            :options="regions"
                                        />
                                        <b-form-input
                                            v-if="request_quotation.isHideShows"
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.other_pickup_region
                                            "
                                            placeholder="Enter pick up "
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsi"
                                            v-model="
                                                request_quotation.isHideShows
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col :cols="6">
                            <validation-provider
                                name="Delivery"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Delivery<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select2
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            class="hide_select"
                                            v-if="
                                                !request_quotation.isHideShowPk
                                            "
                                            :disabled="readonly"
                                            placeholder="Delivery"
                                            v-model="
                                                request_quotation.delivery_region
                                            "
                                            :options="regions"
                                        />
                                        <b-form-input
                                            v-else
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.other_delivery_region
                                            "
                                            placeholder="Enter pick up"
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsPk"
                                            v-model="
                                                request_quotation.isHideShowPk
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!-- <b-col cols="12" lg="4" v-if="step == 'view-quotation-booking'">
              <b-form-group>
                <label>Shipping Type </label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col> -->
                    </b-row>

                    <b-row v-else>
                        <b-col :cols="6">
                            <validation-provider
                                name="Pick up"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Pick up<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select4
                                            v-model="
                                                request_quotation.pickup_location
                                            "
                                            :key="countRq"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid hide_select'
                                                    : 'hide_select'
                                            "
                                            placeholder="Enter Pick up "
                                            v-if="
                                                !request_quotation.isHideShows
                                            "
                                            :disabled="readonly"
                                            :options="{
                                                value: 'id',
                                                label: 'text',
                                                data: locations,
                                                fields: [
                                                    {
                                                        field: 'abbreviations',
                                                        label: 'Abbreviations',
                                                    },
                                                    {
                                                        field: 'name',
                                                        label: 'Location',
                                                    },
                                                    {
                                                        field: 'address',
                                                        label: 'Address',
                                                    },
                                                ],
                                            }"
                                        />
                                        <b-form-input
                                            :disabled="readonly"
                                            v-if="request_quotation.isHideShows"
                                            v-model="
                                                request_quotation.other_pickup_location
                                            "
                                            placeholder="Enter pick up "
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsi"
                                            v-model="
                                                request_quotation.isHideShows
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col :cols="6">
                            <validation-provider
                                name="Delivery"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Delivery<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <div class="d-flex align-items-center">
                                        <Select4
                                            v-model="
                                                request_quotation.delivery_location
                                            "
                                            :key="countRq"
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid hide_select'
                                                    : 'hide_select'
                                            "
                                            placeholder="Enter Delivery "
                                            v-if="
                                                !request_quotation.isHideShowPk
                                            "
                                            :disabled="readonly"
                                            :options="{
                                                value: 'id',
                                                label: 'text',
                                                data: locations,
                                                fields: [
                                                    {
                                                        field: 'abbreviations',
                                                        label: 'Abbreviations',
                                                    },
                                                    {
                                                        field: 'name',
                                                        label: 'Location',
                                                    },
                                                    {
                                                        field: 'address',
                                                        label: 'Address',
                                                    },
                                                ],
                                            }"
                                        />
                                        <b-form-input
                                            v-if="
                                                request_quotation.isHideShowPk
                                            "
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.other_delivery_location
                                            "
                                            placeholder="Enter pick up"
                                        />
                                        <b-form-checkbox
                                            :disabled="readonly"
                                            v-on:change="hideShowsPk"
                                            v-model="
                                                request_quotation.isHideShowPk
                                            "
                                            class="check_input"
                                            >Other
                                        </b-form-checkbox>
                                    </div>
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <!-- <b-col
              cols="12"
              lg="4"
              v-if="step == 'booking' || step == 'view-quotation-booking'"
            >
              <b-form-group>
                <label>Shipping Type </label>
                <Select2
                  :disabled="readonly"
                  placeholder="Shipping Type"
                  v-model="request_quotation.shippingType"
                  :options="
                    request_quotation.service_type == 5
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : request_quotation.service_type == 6
                      ? transport_types.filter((i) =>
                          [1, 2, 3, 4].includes(i.id)
                        )
                      : transport_types.filter((i) => [1, 2].includes(i.id))
                  "
                />
              </b-form-group>
            </b-col> -->
                    </b-row>

                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Pick up date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="request_quotation.pick_up_date"
                                        type="datetime"
                                        class="w-full"
                                        :disabled="readonly"
                                        value-type="format"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Delivery Date</label>

                                <section>
                                    <date-picker
                                        ref="datePicker"
                                        v-model="
                                            request_quotation.delivery_date
                                        "
                                        :disabled-date="disabledRangeDelivery"
                                        type="datetime"
                                        class="w-full"
                                        value-type="format"
                                        :disabled="readonly"
                                        title-format="DD/MM/YY"
                                        time-title-format="DD/MM/YY"
                                        placeholder="Select datetime"
                                        :show-time-panel="showTimePanel"
                                        format="DD/MM/YY HH:mm"
                                        @close="handleOpenChange"
                                    >
                                        <template v-slot:footer>
                                            <button
                                                class="mx-btn mx-btn-text"
                                                @click="toggleTimePanel"
                                            >
                                                {{
                                                    showTimePanel
                                                        ? "Date"
                                                        : "Time"
                                                }}
                                            </button>
                                        </template>
                                    </date-picker>
                                </section>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC pick up"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC pick up</label>
                                    <b-form-input
                                        placeholder="PIC pick up"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICPickUp"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="PIC Delivery"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>PIC Delivery</label>
                                    <b-form-input
                                        placeholder="PIC Delivery"
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.PICDelivery"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col
                            v-if="
                                step != 'booking' &&
                                step != 'view-quotation-booking'
                            "
                            cols="12"
                            lg="6"
                            class="pt-1"
                        >
                            <h4>Freight Informations</h4>
                        </b-col>
                        <b-col
                            cols="12"
                            :lg="
                                step != 'booking' &&
                                step != 'view-quotation-booking'
                                    ? 6
                                    : 12
                            "
                            class="pt-1"
                        >
                            <h4>Cargo Information</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step != 'booking' &&
                                step != 'view-quotation-booking'
                            "
                        >
                            <b-form-group>
                                <label>Volume (Monthly)</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.volume"
                                    placeholder="Volume (Monthly)"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            :lg="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                                    ? 4
                                    : 6
                            "
                        >
                            <validation-provider
                                name="Commodity"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Commodity<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <Select2
                                        :disabled="readonly"
                                        placeholder="Commodity"
                                        v-model="request_quotation.goods_type"
                                        :options="goods_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col
                            cols="12"
                            lg="4"
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                        >
                            <validation-provider
                                name="Commodity description"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Commodity description</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.mo_ta"
                                        placeholder="Commodity description"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col
                            v-if="
                                step == 'booking' ||
                                step == 'view-quotation-booking'
                            "
                            cols="12"
                            lg="4"
                        >
                            <validation-provider
                                name="Gross Weight (kgs)"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Total Gross Weight (kg)</label>

                                    <cleave
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.trong_luong"
                                        class="form-control"
                                        placeholder="Gross Weight (kgs)"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row
                        v-if="
                            step == 'booking' ||
                            step == 'view-quotation-booking'
                        "
                    >
                        <b-col cols="12" lg="4">
                            <b-form-group>
                                <label>Measurement (cbm)</label>
                                <cleave
                                    :options="$Utils.CONSTANTS.cleaveNumeral"
                                    :disabled="readonly"
                                    v-model="request_quotation.so_khoi"
                                    class="form-control"
                                    placeholder="Measurement (kgs)"
                                />
                                <!-- <b-form-input
                  type="number"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  placeholder="Measurement (kgs)"
                /> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Package Type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package Type </label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Package type"
                                        v-model="request_quotation.package_type"
                                        :options="
                                            cont_types.filter(
                                                (i) => i.group === 'packaging'
                                            )
                                        "
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Package Number"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package Number</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="
                                            request_quotation.packageNumber
                                        "
                                        placeholder="Package Number"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4" class="pt-1">
                            <h4>Other service</h4>
                        </b-col>
                        <b-col cols="3" class="pt-1">
                            <b-form-checkbox
                                :disabled="readonly"
                                v-model="request_quotation.has_customs"
                                >Customs services
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row v-if="request_quotation.has_customs">
                        <b-col cols="12" lg="12" class="pt-1">
                            <h4>Customs declaration information</h4>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Customs type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Customs type </label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Customs type"
                                        v-model="request_quotation.customs_type"
                                        :options="customs_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Business type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Business type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Business type"
                                        v-model="
                                            request_quotation.business_type
                                        "
                                        :options="business_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Place of Custom declaration"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Place of Custom declaration </label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.customs_addr"
                                        placeholder="Place of Custom declaration"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>HS Code</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.hs_code"
                                    placeholder="HS Code"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Notes</label>
                                <b-form-textarea
                                    rows="5"
                                    :disabled="readonly"
                                    v-model="request_quotation.notes"
                                    placeholder="Notes"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- multi file upload starts -->
                </div>

                <!--customs-->
                <div v-if="request_quotation.service_type == 4">
                    <b-row>
                        <b-col cols="12" lg="12" class="pt-1">
                            <h4>Customs declaration information</h4>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Customs type"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Customs type<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Customs type"
                                        v-model="request_quotation.customs_type"
                                        :options="customs_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <validation-provider
                                name="Business type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Business type</label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Business type"
                                        v-model="
                                            request_quotation.business_type
                                        "
                                        :options="business_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>Place of Custom declaration</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.customs_addr"
                                    placeholder="Place of Custom declaration"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group>
                                <label>HS Code</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.hs_code"
                                    placeholder="HS Code"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col
                            v-if="
                                step != 'booking' &&
                                step != 'view-quotation-booking'
                            "
                            cols="12"
                            lg="6"
                            class="pt-1"
                        >
                            <h4>Freight Informations</h4>
                        </b-col>
                        <b-col
                            cols="12"
                            :lg="
                                step != 'booking' &&
                                step != 'view-quotation-booking'
                                    ? 6
                                    : 12
                            "
                            class="pt-1"
                        >
                            <h4>Cargo Information</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                            cols="12"
                            lg="6"
                            v-if="
                                step != 'booking' &&
                                step != 'view-quotation-booking'
                            "
                        >
                            <b-form-group>
                                <label>Volume (Monthly)</label>
                                <b-form-input
                                    :disabled="readonly"
                                    v-model="request_quotation.volume"
                                    placeholder="Volume (Monthly)"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            :lg="
                                (step == 'booking' ||
                                    step == 'view-quotation-booking') &&
                                request_quotation.customs_other_service_type ==
                                    'VAN'
                                    ? 4
                                    : step == 'booking' ||
                                      step == 'view-quotation-booking'
                                    ? 6
                                    : 3
                            "
                        >
                            <validation-provider
                                name="Commodity"
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group>
                                    <label
                                        >Commodity<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <Select2
                                        :disabled="readonly"
                                        placeholder="Commodity"
                                        v-model="request_quotation.goods_type"
                                        :options="goods_types"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col
                            cols="12"
                            :lg="
                                (step == 'booking' ||
                                    step == 'view-quotation-booking') &&
                                request_quotation.customs_other_service_type ==
                                    'VAN'
                                    ? 4
                                    : step == 'booking' ||
                                      step == 'view-quotation-booking'
                                    ? 6
                                    : 3
                            "
                        >
                            <validation-provider
                                name="Commodity description"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Commodity description</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.mo_ta"
                                        placeholder="Commodity description"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col
                            v-if="
                                (step == 'booking' ||
                                    step == 'view-quotation-booking') &&
                                request_quotation.customs_other_service_type ==
                                    'VAN'
                            "
                            cols="12"
                            lg="4"
                        >
                            <validation-provider
                                name="Gross Weight (kgs)"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Total Gross Weight (kg)</label>

                                    <cleave
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :options="
                                            $Utils.CONSTANTS.cleaveNumeral
                                        "
                                        :disabled="readonly"
                                        v-model="request_quotation.trong_luong"
                                        class="form-control"
                                        placeholder="Gross Weight (kgs)"
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row
                        v-if="
                            (step == 'booking' ||
                                step == 'view-quotation-booking') &&
                            request_quotation.customs_other_service_type ==
                                'VAN'
                        "
                    >
                        <b-col cols="12" lg="4">
                            <b-form-group>
                                <label>Measurement (cbm)</label>
                                <cleave
                                    :options="$Utils.CONSTANTS.cleaveNumeral"
                                    :disabled="readonly"
                                    v-model="request_quotation.so_khoi"
                                    class="form-control"
                                    placeholder="Measurement (kgs)"
                                />
                                <!-- <b-form-input
                  type="number"
                  :disabled="readonly"
                  v-model="request_quotation.so_khoi"
                  placeholder="Measurement (kgs)"
                /> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Package Type"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package Type </label>
                                    <Select2
                                        :class="
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null
                                        "
                                        :disabled="readonly"
                                        placeholder="Package type"
                                        v-model="request_quotation.package_type"
                                        :options="
                                            cont_types.filter(
                                                (i) => i.group === 'packaging'
                                            )
                                        "
                                    />
                                    <small
                                        class="text-danger"
                                        v-show="errors.length > 0"
                                        >{{ errors[0] }}</small
                                    >
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <validation-provider
                                name="Package Number"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Package Number</label>
                                    <b-form-input
                                        :state="
                                            errors.length > 0 ? false : null
                                        "
                                        :disabled="readonly"
                                        v-model="
                                            request_quotation.packageNumber
                                        "
                                        placeholder="Package Number"
                                    />
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>

                    <b-row
                        v-if="
                            (step == 'booking' ||
                                step == 'view-quotation-booking') &&
                            request_quotation.customs_other_service_type ==
                                'CONTAINER'
                        "
                    >
                        <b-col cols="12" class="pt-1">
                            <h4>Freight Informations</h4>
                        </b-col>
                        <b-col cols="12">
                            <validation-provider
                                name="Carrier"
                                #default="{ errors }"
                                rules=""
                            >
                                <b-form-group>
                                    <label>Carrier</label>
                                    <Select4
                                        v-model="
                                            request_quotation.shipping_line
                                        "
                                        :class="[
                                            errors.length > 0
                                                ? 'is-invalid'
                                                : null,
                                            readonly == true ? 'remove' : '',
                                        ]"
                                        placeholder="Carrier"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'id',
                                            label: 'text',
                                            data: shipping_lines,
                                            fields: [
                                                {
                                                    field: 'code',
                                                    label: 'Code',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Shipping Line',
                                                },
                                            ],
                                        }"
                                    />
                                    <small class="text-danger">{{
                                        errors[0]
                                    }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <!-- <b-row>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Commodity"
                    v-model="request_quotation.goods_type"
                    :options="goods_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <validation-provider
                name="Commodity description"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Commodity description<font class="red">*</font></label>
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.mo_ta"
                    placeholder="Commodity description"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group>
                <label>Volume (Monthly)</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                />
              </b-form-group>
            </b-col>
          </b-row> -->
                    <b-row>
                        <b-col cols="12" lg="4" class="pt-1">
                            <h4 class="float-left">Other service</h4>
                            <b-button
                                @click="
                                    request_quotation.customs_other_service_type =
                                        null
                                "
                                variant="flat-danger"
                                :class="{ 'd-none': readonly }"
                                class="p-0 m-0 ml-1 float-left"
                            >
                                <feather-icon size="1.2x" icon="TrashIcon" />
                            </b-button>
                        </b-col>
                        <b-col cols="12" lg="4" class="pt-1">
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio-group
                                    v-model="
                                        request_quotation.customs_other_service_type
                                    "
                                    :options="[
                                        {
                                            text: 'Container Trucking',
                                            value: 'CONTAINER',
                                        },
                                        { text: 'Van Trucking', value: 'VAN' },
                                    ]"
                                    :disabled="readonly"
                                    :aria-describedby="ariaDescribedby"
                                    name="radio-options"
                                >
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div
                        v-if="
                            request_quotation.customs_other_service_type ==
                            'VAN'
                        "
                    >
                        <b-row>
                            <b-col cols="12">
                                <h4>Shipment Informations</h4>
                            </b-col>
                        </b-row>
                        <b-row
                            v-if="
                                (step == 'booking' ||
                                    step == 'view-quotation-booking') &&
                                request_quotation.customs_other_service_type ==
                                    'VAN'
                            "
                        >
                            <b-col cols="12" lg="6">
                                <b-form-group>
                                    <label>Booking/HBL/INV</label>
                                    <b-form-input
                                        :disabled="readonly"
                                        placeholder="Booking/HBL/INV"
                                        v-model="request_quotation.HBL"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <b-form-group>
                                    <label>Shipping Type</label>
                                    <Select2
                                        :disabled="readonly"
                                        placeholder="Shipping Type"
                                        v-model="request_quotation.shippingType"
                                        :options="
                                            request_quotation.service_type == 5
                                                ? transport_types.filter((i) =>
                                                      [1, 2, 3, 4].includes(
                                                          i.id
                                                      )
                                                  )
                                                : request_quotation.service_type ==
                                                  6
                                                ? transport_types.filter((i) =>
                                                      [1, 2, 3, 4].includes(
                                                          i.id
                                                      )
                                                  )
                                                : transport_types.filter((i) =>
                                                      [1, 2].includes(i.id)
                                                  )
                                        "
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Truck Type"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>Truck Type</label>
                                        <Select2
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            :disabled="readonly"
                                            placeholder="Truck Type"
                                            v-model="
                                                request_quotation.truck_type
                                            "
                                            :options="
                                                cont_types.filter(
                                                    (i) =>
                                                        i.group === 'van truck'
                                                )
                                            "
                                        />
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Quantity"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>Quantity</label>
                                        <b-form-input
                                            placeholder="Quantity"
                                            type="number"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="request_quotation.so_luong"
                                        />
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>

                        <b-row
                            v-if="
                                step == 'created-quotation' ||
                                step == 'view-created-quotation' ||
                                (step == 'view-quotation-booking' &&
                                    (request_quotation.pickup_region != null ||
                                        request_quotation.other_pickup_region) &&
                                    step != 'booking')
                            "
                        >
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                placeholder="Pick up"
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                v-model="
                                                    request_quotation.pickup_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_pickup_region
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                placeholder="Delivery"
                                                v-model="
                                                    request_quotation.delivery_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.other_delivery_region
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>

                        <b-row v-else>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.pickup_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Pick up "
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_pickup_location
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.delivery_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Delivery "
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_delivery_location
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row> </b-row>
                        <b-row
                            v-if="
                                request_quotation.customs_other_service_type ==
                                    'VAN' &&
                                (step == 'booking' ||
                                    step == 'view-quotation-booking')
                            "
                        >
                            <b-col cols="12" lg="6">
                                <b-form-group>
                                    <label>Pick up date</label>

                                    <section>
                                        <date-picker
                                            ref="datePicker"
                                            v-model="
                                                request_quotation.pick_up_date
                                            "
                                            type="datetime"
                                            class="w-full"
                                            :disabled="readonly"
                                            value-type="format"
                                            title-format="DD/MM/YY"
                                            time-title-format="DD/MM/YY"
                                            placeholder="Select datetime"
                                            :show-time-panel="showTimePanel"
                                            format="DD/MM/YY HH:mm"
                                            @close="handleOpenChange"
                                        >
                                            <template v-slot:footer>
                                                <button
                                                    class="mx-btn mx-btn-text"
                                                    @click="toggleTimePanel"
                                                >
                                                    {{
                                                        showTimePanel
                                                            ? "Date"
                                                            : "Time"
                                                    }}
                                                </button>
                                            </template>
                                        </date-picker>
                                    </section>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <b-form-group>
                                    <label>Delivery Date</label>

                                    <section>
                                        <date-picker
                                            ref="datePicker"
                                            v-model="
                                                request_quotation.delivery_date
                                            "
                                            :disabled-date="
                                                disabledRangeDelivery
                                            "
                                            type="datetime"
                                            class="w-full"
                                            value-type="format"
                                            :disabled="readonly"
                                            title-format="DD/MM/YY"
                                            time-title-format="DD/MM/YY"
                                            placeholder="Select datetime"
                                            :show-time-panel="showTimePanel"
                                            format="DD/MM/YY HH:mm"
                                            @close="handleOpenChange"
                                        >
                                            <template v-slot:footer>
                                                <button
                                                    class="mx-btn mx-btn-text"
                                                    @click="toggleTimePanel"
                                                >
                                                    {{
                                                        showTimePanel
                                                            ? "Date"
                                                            : "Time"
                                                    }}
                                                </button>
                                            </template>
                                        </date-picker>
                                    </section>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="PIC pick up"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>PIC pick up</label>
                                        <b-form-input
                                            placeholder="PIC pick up"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.PICPickUp
                                            "
                                        />
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="PIC Delivery"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>PIC Delivery</label>
                                        <b-form-input
                                            placeholder="PIC Delivery"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.PICDelivery
                                            "
                                        />
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </div>
                    <div
                        v-if="
                            request_quotation.customs_other_service_type ==
                            'CONTAINER'
                        "
                    >
                        <b-row>
                            <b-col cols="12">
                                <h4>Shipment Informations</h4>
                            </b-col>
                        </b-row>
                        <b-row
                            v-if="
                                (step == 'booking' ||
                                    step == 'view-quotation-booking') &&
                                request_quotation.customs_other_service_type ==
                                    'CONTAINER'
                            "
                        >
                            <b-col cols="12" lg="6">
                                <b-form-group>
                                    <label>Booking/HBL/INV</label>
                                    <b-form-input
                                        :disabled="readonly"
                                        placeholder="Booking/HBL/INV"
                                        v-model="request_quotation.HBL"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <b-form-group>
                                    <label>Shipping Type</label>
                                    <Select2
                                        :disabled="readonly"
                                        placeholder="Shipping Type"
                                        v-model="request_quotation.shippingType"
                                        :options="
                                            request_quotation.service_type == 5
                                                ? transport_types.filter((i) =>
                                                      [1, 2, 3, 4].includes(
                                                          i.id
                                                      )
                                                  )
                                                : request_quotation.service_type ==
                                                  6
                                                ? transport_types.filter((i) =>
                                                      [1, 2, 3, 4].includes(
                                                          i.id
                                                      )
                                                  )
                                                : transport_types.filter((i) =>
                                                      [1, 2].includes(i.id)
                                                  )
                                        "
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Container Type"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>Container Type</label>
                                        <Select2
                                            :class="
                                                errors.length > 0
                                                    ? 'is-invalid'
                                                    : null
                                            "
                                            :disabled="readonly"
                                            placeholder="Container Type"
                                            v-model="
                                                request_quotation.cont_type
                                            "
                                            :options="
                                                cont_types.filter(
                                                    (i) =>
                                                        i.group ===
                                                        'Container truck'
                                                )
                                            "
                                        />
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>

                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Quantity"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>Quantity</label>
                                        <b-form-input
                                            placeholder="Quantity"
                                            type="number"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="request_quotation.so_luong"
                                        />
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row v-if="step == 'booking'">
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Container No."
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>Container No.</label>
                                        <b-form-input
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.container_no
                                            "
                                            placeholder="Quantity"
                                        />
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="Seal No."
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>Seal No.</label>
                                        <b-form-input
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="request_quotation.seal"
                                            placeholder="Quantity"
                                        />
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col
                                cols="12"
                                lg="4"
                                v-if="
                                    step == 'created-quotation' ||
                                    step == 'view-created-quotation' ||
                                    (step == 'view-quotation-booking' &&
                                        (request_quotation.pickup_region !=
                                            null ||
                                            request_quotation.other_pickup_region) &&
                                        step != 'booking')
                                "
                            >
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                placeholder="Pick up"
                                                v-model="
                                                    request_quotation.pickup_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                v-model="
                                                    request_quotation.other_pickup_region
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col
                                cols="12"
                                lg="4"
                                v-if="
                                    step == 'created-quotation' ||
                                    step == 'view-created-quotation' ||
                                    (step == 'view-quotation-booking' &&
                                        (request_quotation.delivery_region !=
                                            null ||
                                            request_quotation.other_delivery_region) &&
                                        step != 'booking')
                                "
                            >
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select2
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                class="hide_select"
                                                :disabled="readonly"
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                placeholder="Delivery"
                                                v-model="
                                                    request_quotation.delivery_region
                                                "
                                                :options="regions"
                                            />
                                            <b-form-input
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                v-model="
                                                    request_quotation.other_delivery_region
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>

                            <b-col
                                cols="12"
                                lg="4"
                                v-if="
                                    (step != 'created-quotation' &&
                                        step != 'view-created-quotation' &&
                                        step == 'view-quotation-booking' &&
                                        (request_quotation.pickup_location !=
                                            null ||
                                            request_quotation.other_pickup_location !=
                                                null)) ||
                                    step == 'booking'
                                "
                            >
                                <validation-provider
                                    name="Pick up"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Pick up<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.pickup_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Pick up "
                                                v-if="
                                                    !request_quotation.isHideShows
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShows
                                                "
                                                v-model="
                                                    request_quotation.other_pickup_location
                                                "
                                                placeholder="Enter pick up "
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsi"
                                                v-model="
                                                    request_quotation.isHideShows
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col
                                cols="12"
                                lg="4"
                                v-if="
                                    (step != 'created-quotation' &&
                                        step != 'view-created-quotation' &&
                                        step == 'view-quotation-booking' &&
                                        (request_quotation.delivery_location !=
                                            null ||
                                            request_quotation.other_delivery_location !=
                                                null)) ||
                                    step == 'booking'
                                "
                            >
                                <validation-provider
                                    name="Delivery"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group>
                                        <label
                                            >Delivery<font class="red"
                                                >*</font
                                            ></label
                                        >
                                        <div class="d-flex align-items-center">
                                            <Select4
                                                v-model="
                                                    request_quotation.delivery_location
                                                "
                                                :key="countRq"
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid hide_select'
                                                        : 'hide_select'
                                                "
                                                placeholder="Enter Delivery "
                                                v-if="
                                                    !request_quotation.isHideShowPk
                                                "
                                                :disabled="readonly"
                                                :options="{
                                                    value: 'id',
                                                    label: 'text',
                                                    data: locations,
                                                    fields: [
                                                        {
                                                            field: 'abbreviations',
                                                            label: 'Abbreviations',
                                                        },
                                                        {
                                                            field: 'name',
                                                            label: 'Location',
                                                        },
                                                        {
                                                            field: 'address',
                                                            label: 'Address',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <b-form-input
                                                :disabled="readonly"
                                                v-if="
                                                    request_quotation.isHideShowPk
                                                "
                                                v-model="
                                                    request_quotation.other_delivery_location
                                                "
                                                placeholder="Enter pick up"
                                            />
                                            <b-form-checkbox
                                                :disabled="readonly"
                                                v-on:change="hideShowsPk"
                                                v-model="
                                                    request_quotation.isHideShowPk
                                                "
                                                class="check_input"
                                                >Other
                                            </b-form-checkbox>
                                        </div>
                                        <small
                                            class="text-danger"
                                            v-show="errors.length > 0"
                                            >{{ errors[0] }}</small
                                        >
                                    </b-form-group>
                                </validation-provider>
                            </b-col>

                            <b-col
                                cols="12"
                                lg="4"
                                v-if="
                                    (step != 'created-quotation' &&
                                        step != 'view-created-quotation' &&
                                        step == 'view-quotation-booking' &&
                                        request_quotation.deport_location !=
                                            null) ||
                                    step == 'booking'
                                "
                            >
                                <b-form-group>
                                    <label
                                        >Empty depot<font class="red"
                                            >*</font
                                        ></label
                                    >

                                    <Select4
                                        v-model="
                                            request_quotation.deport_location
                                        "
                                        :key="countRq"
                                        placeholder="Empty depot"
                                        :disabled="readonly"
                                        :options="{
                                            value: 'id',
                                            label: 'text',
                                            data: locations,
                                            fields: [
                                                {
                                                    field: 'abbreviations',
                                                    label: 'Abbreviations',
                                                },
                                                {
                                                    field: 'name',
                                                    label: 'Location',
                                                },
                                                {
                                                    field: 'address',
                                                    label: 'Address',
                                                },
                                            ],
                                        }"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="4" v-else>
                                <b-form-group>
                                    <label
                                        >Empty depot<font class="red"
                                            >*</font
                                        ></label
                                    >
                                    <Select2
                                        :disabled="readonly"
                                        placeholder="Empty depot"
                                        v-model="request_quotation.deport"
                                        :options="regions"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row
                            v-if="
                                request_quotation.customs_other_service_type ==
                                    'CONTAINER' &&
                                (step == 'booking' ||
                                    step == 'view-quotation-booking')
                            "
                        >
                            <b-col cols="12" lg="4">
                                <b-form-group>
                                    <label>Pick up date</label>

                                    <section>
                                        <date-picker
                                            ref="datePicker"
                                            v-model="
                                                request_quotation.pick_up_date
                                            "
                                            type="datetime"
                                            class="w-full"
                                            :disabled="readonly"
                                            value-type="format"
                                            title-format="DD/MM/YY"
                                            time-title-format="DD/MM/YY"
                                            placeholder="Select datetime"
                                            :show-time-panel="showTimePanel"
                                            format="DD/MM/YY HH:mm"
                                            @close="handleOpenChange"
                                        >
                                            <template v-slot:footer>
                                                <button
                                                    class="mx-btn mx-btn-text"
                                                    @click="toggleTimePanel"
                                                >
                                                    {{
                                                        showTimePanel
                                                            ? "Date"
                                                            : "Time"
                                                    }}
                                                </button>
                                            </template>
                                        </date-picker>
                                    </section>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="4">
                                <b-form-group>
                                    <label>Delivery Date</label>

                                    <section>
                                        <date-picker
                                            ref="datePicker"
                                            v-model="
                                                request_quotation.delivery_date
                                            "
                                            :disabled-date="
                                                disabledRangeDelivery
                                            "
                                            type="datetime"
                                            class="w-full"
                                            value-type="format"
                                            :disabled="readonly"
                                            title-format="DD/MM/YY"
                                            time-title-format="DD/MM/YY"
                                            placeholder="Select datetime"
                                            :show-time-panel="showTimePanel"
                                            format="DD/MM/YY HH:mm"
                                            @close="handleOpenChange"
                                        >
                                            <template v-slot:footer>
                                                <button
                                                    class="mx-btn mx-btn-text"
                                                    @click="toggleTimePanel"
                                                >
                                                    {{
                                                        showTimePanel
                                                            ? "Date"
                                                            : "Time"
                                                    }}
                                                </button>
                                            </template>
                                        </date-picker>
                                    </section>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="4">
                                <b-form-group>
                                    <label>Cut off Date</label>

                                    <section>
                                        <date-picker
                                            ref="datePicker"
                                            v-model="
                                                request_quotation.cutOffDate
                                            "
                                            type="datetime"
                                            class="w-full"
                                            :disabled="readonly"
                                            value-type="format"
                                            title-format="DD/MM/YY"
                                            time-title-format="DD/MM/YY"
                                            placeholder="Select datetime"
                                            :show-time-panel="showTimePanel"
                                            format="DD/MM/YY HH:mm"
                                            @close="handleOpenChange"
                                        >
                                            <template v-slot:footer>
                                                <button
                                                    class="mx-btn mx-btn-text"
                                                    @click="toggleTimePanel"
                                                >
                                                    {{
                                                        showTimePanel
                                                            ? "Date"
                                                            : "Time"
                                                    }}
                                                </button>
                                            </template>
                                        </date-picker>
                                    </section>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="PIC pick up"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>PIC pick up</label>
                                        <b-form-input
                                            placeholder="PIC pick up"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.PICPickUp
                                            "
                                        />
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <validation-provider
                                    name="PIC Delivery"
                                    #default="{ errors }"
                                    rules=""
                                >
                                    <b-form-group>
                                        <label>PIC Delivery</label>
                                        <b-form-input
                                            placeholder="PIC Delivery"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :disabled="readonly"
                                            v-model="
                                                request_quotation.PICDelivery
                                            "
                                        />
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Notes</label>
                                <b-form-textarea
                                    rows="5"
                                    :disabled="readonly"
                                    v-model="request_quotation.notes"
                                    placeholder="Notes"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="
                            request_quotation.customs_other_service_type ==
                                'CONTAINER' &&
                            (step == 'booking' ||
                                step == 'view-quotation-booking')
                        "
                    >
                        <b-col cols="12">
                            <b-form-group>
                                <label>Billing information</label>
                                <b-form-textarea
                                    rows="5"
                                    :disabled="readonly"
                                    v-model="
                                        request_quotation.billingInformation
                                    "
                                    placeholder="Billing information"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>

                <b-row v-if="!readonly">
                    <b-col cols="12">
                        <!-- <AttachFile ref="attachFile" /> -->
                    </b-col>
                </b-row>
                <b-row class="pb-1 pt-2">
                    <b-col cols="12">
                        <a
                            v-if="
                                !readonly &&
                                view_RequestQuotation == null &&
                                step != 'booking' &&
                                isCustomer
                            "
                            @click="sendRequestQuotation"
                            class="btn round btn-success pl-4 pr-4 mr-1"
                        >
                            <feather-icon icon="SendIcon" /> Send
                        </a>
                        <a
                            v-if="
                                !readonly &&
                                view_RequestQuotation != null &&
                                step != 'booking' &&
                                step != 'created-quotation'
                            "
                            @click="sendRequestQuotation"
                            class="btn round btn-success pl-4 pr-4 mr-1"
                        >
                            <feather-icon icon="SendIcon" /> Save
                        </a>
                        <a
                            v-if="
                                (!readonly &&
                                    step == 'booking' &&
                                    view_RequestQuotation == null &&
                                    isCustomer) ||
                                (readonlyService &&
                                    view_RequestQuotation != null &&
                                    isCustomer)
                            "
                            @click="sendRequestQuotation"
                            class="btn round btn-success pl-4 pr-4 mr-1"
                        >
                            <feather-icon icon="SendIcon" /> New Booking
                        </a>
                        <a
                            v-if="
                                !readonly &&
                                step == 'booking' &&
                                view_RequestQuotation != null &&
                                !readonlyService &&
                                isCustomer
                            "
                            @click="sendRequestQuotation"
                            class="btn round btn-success pl-4 pr-4 mr-1"
                        >
                            <feather-icon icon="SendIcon" /> Edit Booking
                        </a>
                    </b-col>
                </b-row>
            </validation-observer>
        </b-card>
        <b-modal
            id="modal-regiter"
            :title="$t('REGISTRATION')"
            size="md"
            hide-footer
        >
            <b-card-text>
                <div class="px-2 auth">
                    <div class="auth-left">
                        <validation-observer
                            ref="registerForm"
                            #default="{ invalid }"
                        >
                            <b-form
                                class="auth-login-form mt-2"
                                @submit.prevent="login"
                            >
                                <!-- email -->
                                <b-form-group>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Company name"
                                        rules="required"
                                    >
                                        <label class="pl-1">
                                            {{ $t("companyName")
                                            }}<span class="required">*</span>
                                        </label>

                                        <b-form-input
                                            v-model="user.companyName"
                                            class="round"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :placeholder="
                                                $t('enterCompanyName')
                                            "
                                            autofocus
                                        />
                                        <small
                                            v-show="errors.length > 0"
                                            class="text-danger"
                                            >{{ errors[0] }}</small
                                        >
                                    </validation-provider>
                                </b-form-group>
                                <!-- email -->
                                <b-form-group>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Tax Code"
                                        rules="required"
                                    >
                                        <label class="pl-1">
                                            {{ $t("taxCode")
                                            }}<span class="required"
                                                >*</span
                                            ></label
                                        >
                                        <b-form-input
                                            v-model="user.taxCode"
                                            class="round"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :placeholder="$t('enterTaxCode')"
                                        />
                                        <small
                                            v-show="errors.length > 0"
                                            class="text-danger"
                                            >{{ errors[0] }}</small
                                        >
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Address"
                                        rules="required"
                                    >
                                        <label class="pl-1">
                                            {{ $t("address")
                                            }}<span class="required"
                                                >*</span
                                            ></label
                                        >
                                        <b-form-input
                                            v-model="user.companyAddress"
                                            class="round"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :placeholder="$t('enterAddress')"
                                        />
                                        <small
                                            v-show="errors.length > 0"
                                            class="text-danger"
                                            >{{ errors[0] }}</small
                                        >
                                    </validation-provider>
                                </b-form-group>
                                <!-- email -->
                                <b-form-group>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Contact name"
                                        rules="required"
                                    >
                                        <label class="pl-1"
                                            >{{ $t("contactName")
                                            }}<span class="required"
                                                >*</span
                                            ></label
                                        >
                                        <b-form-input
                                            v-model="user.fullName"
                                            class="round"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :placeholder="$t('placeholderName')"
                                        />
                                        <small
                                            v-show="errors.length > 0"
                                            class="text-danger"
                                            >{{ errors[0] }}</small
                                        >
                                    </validation-provider>
                                </b-form-group>
                                <!-- email -->

                                <label class="pl-1">
                                    {{ $t("gender")
                                    }}<span class="required">*</span></label
                                >
                                <b-form-group class="pl-1 pt-1">
                                    <b-row>
                                        <b-col cols="4">
                                            <b-form-radio
                                                v-model="user.genderId"
                                                name="some-radios"
                                                value="1"
                                            >
                                                {{ $t("Male") }}
                                            </b-form-radio>
                                        </b-col>
                                        <b-col cols="4">
                                            <b-form-radio
                                                v-model="user.genderId"
                                                name="some-radios"
                                                value="2"
                                            >
                                                {{ $t("Female") }}
                                            </b-form-radio>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <!-- email -->
                                <b-form-group>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Phone"
                                        rules="required|regex:^([0-9]+)$"
                                    >
                                        <label class="pl-1">
                                            {{ $t("phone")
                                            }}<span class="required">*</span>
                                            (Only Phone)</label
                                        >
                                        <b-form-input
                                            v-model="user.phone"
                                            class="round"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :placeholder="
                                                $t('placeholderPhone')
                                            "
                                        />
                                        <small
                                            v-show="errors.length > 0"
                                            class="text-danger"
                                            >{{ errors[0] }}</small
                                        >
                                    </validation-provider>
                                </b-form-group>
                                <!-- email -->
                                <b-form-group>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Email"
                                        rules="required|email"
                                    >
                                        <label class="pl-1">
                                            {{ $t("email")
                                            }}<span class="required">*</span>
                                            (eg.: joe@xyz.com)</label
                                        >
                                        <b-form-input
                                            v-model="user.email"
                                            class="round"
                                            :state="
                                                errors.length > 0 ? false : null
                                            "
                                            :placeholder="$t('enterEmail')"
                                        />
                                        <small
                                            v-show="errors.length > 0"
                                            class="text-danger"
                                            >{{ errors[0] }}</small
                                        >
                                    </validation-provider>
                                </b-form-group>
                                <!-- email -->

                                <!-- checkbox -->
                                <b-form-group>
                                    <span class="text-danger">{{
                                        errMsg
                                    }}</span>
                                </b-form-group>

                                <!-- submit button -->
                                <b-form-group class="text-center">
                                    <a
                                        class="font-weight-bolder h3 text-success"
                                        @click="register"
                                        :disabled="invalid"
                                        >{{ $t("register") }}</a
                                    >
                                </b-form-group>
                            </b-form>
                        </validation-observer>
                    </div>
                </div>
            </b-card-text>
        </b-modal>
    </div>
</template>
<style>
.container_sc {
    width: 90%;
}
.remove .select2-selection--single::before {
    background-image: none !important;
}

.is-invalid .select2-selection--single {
    border: 1px solid #ea5455;
}
.select2-selection--single::before {
    content: "";
    position: absolute;
    right: 14px;
    top: 0;
    bottom: 0;
    width: 14px;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
}
.select2-hidden-accessible::before {
    content: "";
    position: absolute;
    right: 14px;
    top: 0;
    bottom: 0;
    width: 14px;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
}
.select2-selection--single:before {
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=)
        center / contain no-repeat;
}
.select2-hidden-accessible:before {
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=)
        center / contain no-repeat;
}
.red {
    color: red;
}
.vue-dropzone > .dz-preview .dz-details {
    background-color: #2b938c;
    border-radius: 15px;
}

.hide_input {
    display: none;
}
.hide_show .hide_input {
    display: block;
}
.hide_input {
    width: 80%;
}
.hide_show .hide_select {
    display: none;
}

.check_input {
    width: 10%;
    margin-left: 30px;
}
.select2-container--default
    .select2-selection--single
    .select2-selection__arrow
    b {
    display: none;
}
</style>
<script>
import {
    BButton,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState, mapActions } from "vuex";

import { $ctx } from "@themeConfig";

export default {
    props: {
        cards: {},
        className: { default: "booking-online" },
        readonly: { default: false, type: Boolean },
        view_RequestQuotation: { default: null },
        step: { default: null },
        isCustomer: { default: true },
    },
    components: {
        BButton,
        ValidationProvider,
        BCardText,
        ValidationObserver,
        BFormInput,
        BFormCheckbox,
        BFormRadioGroup,
        BFormRadio,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BInputGroupPrepend,
        BFormDatepicker,
        BRow,
        BCol,
        BTable,
        BCard,
        BCardText,
        Select2,
        vueDropzone: vue2Dropzone,
        FeatherIcon,
    },
    data() {
        return {
            user: { genderId: 1 },
            bankItems: [],
            // validation rules

            errMsg: "",
            readonlyService: false,
            isHideShow: false,
            isHideShowPk: false,
            vm: this,
            userData: JSON.parse(localStorage.getItem("userData")),

            dropzoneOptions: {
                url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
                addRemoveLinks: !this.readonly,
                acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
                maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
                maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
                headers: { apiKey: localStorage.getItem("accessToken") },
                clickable: !this.readonly,
            },
            request_quotation: {
                company_id: null,
                service_type: null,
                pod_port: null,
                pol_port: null,
                incoterms: null,
                pickup_location: null,
                delivery_location: null,
                cont_type: null,
                goods_type: null,
                package_type: null,
                transport_type: null,
                deport: null,
                business_type: null,
                so_luong: null,
                trong_luong: null,
                mo_ta: null,
                other_pickup_location: null,
                other_delivery_location: null,
                volume: null,
                from_date: null,
                to_date: null,
                other_service: null,
                note: null,
                so_khoi: null,
                so_kien: null,
                size_: {
                    length_: null,
                    width_: null,
                    height_: null,
                },
                customs_addr: null,
                hs_code: null,
            },

            sales_list: null,
            company_list: null,
            customer_list_options: null,
            showTimePanel: false,
            package_types: [
                { id: 1, text: "Rotatable" },
                { id: 2, text: "Stackable" },
                { id: 3, text: "Non-stackable" },
            ],
            volumes: [
                { id: 1, text: "1-10" },
                { id: 2, text: "10-30" },
                { id: 3, text: "30-50" },
                { id: 4, text: "50-100" },
                { id: 5, text: ">100" },
            ],
            customer_list: null,
        };
    },
    computed: {
        ...mapState("masterDataNoLogin", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "locations",
            "transport_types",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "handed_types",
        ]),
    },
    watch: {
        "request_quotation.service_type": function (n, o) {
            if (this.$refs.requestQuotationRules)
                this.$refs.requestQuotationRules.reset();

            this.$emit("serviceType", n);
        },
        "request_quotation.company_id": function (n, o) {
            useJwt
                .get("wr1?objectType=CustomerListCompany", {
                    params: { search: n },
                })
                .then((response) => {
                    this.customer_list_options = this.formatOption(
                        response.data.result
                    );
                    this.request_quotation.customer_id =
                        this.customer_list_options.filter(
                            (e) => e.user_type == 2
                        )[0];
                });
        },
    },
    created() {
        if (JSON.parse(localStorage.getItem("userData"))) {
            this.$router
                .replace({
                    name: "my-wr1-quotation",
                })
                .catch((error) => {});
        }
        this.$store.dispatch("masterDataNoLogin/FETCH_ALL");
    },
    mounted() {
        this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
            document
                .getElementsByClassName("modal-content")
                .forEach(function (v) {
                    v.removeAttribute("tabindex");
                });
        });
        // useJwt.get("masterData?data=All", {}).then((response) => {
        //   this.service_types = response.data.result.ServiceType;
        //   this.ports = this.formatOption(response.data.result.Port);
        //   this.incoterms = this.formatOption(response.data.result.Incoterm);
        //   this.locations = response.data.result.Location;
        //   this.cont_types = response.data.result.ContType;
        //   this.goods_types = response.data.result.GoodsType;
        //   this.transport_types = response.data.result.TransportType;
        //   this.deports = response.data.result.Deport;
        //   this.business_types = response.data.result.BusinessType;
        //   this.customs_types = response.data.result.CustomsType;
        //   this.company_list = this.formatOption(response.data.result.Company);
        //   this.shipping_lines = response.data.result.ShippingLine;
        // });

        if (this.view_RequestQuotation != null) {
            this.request_quotation = this.view_RequestQuotation;
            this.request_quotation.bookingID = this.view_RequestQuotation.id;
            this.request_quotation.sale_name =
                this.view_RequestQuotation.sale_name;
            this.request_quotation.customer_name =
                this.view_RequestQuotation.customer_name;
            this.request_quotation.customer_phone =
                this.view_RequestQuotation.customer_phone;
            this.request_quotation.customer_email =
                this.view_RequestQuotation.customer_email;
            this.request_quotation.customer_company_name =
                this.view_RequestQuotation.customer_company_name;
            this.view_RequestQuotation.customer_company_name;
        }
    },
    methods: {
        toggleTimePanel() {
            this.showTimePanel = !this.showTimePanel;
        },
        toggleTimeRangePanel() {
            this.showTimeRangePanel = !this.showTimeRangePanel;
        },
        handleCloseChange() {
            this.$refs.datePicker.popupVisible = false;
        },
        handleOpenChange() {
            this.showTimePanel = false;
        },
        handleRangeClose() {
            this.showTimeRangePanel = false;
        },
        register() {
            this.$refs.registerForm.validate().then((success) => {
                if (success) {
                    useJwt
                        .post("userListNoLogin", {
                            registerInfo: JSON.stringify({ ...this.user }),
                            ...this.user,
                            quotationInfo: JSON.stringify(
                                this.request_quotation
                            ).toString(),
                        })
                        .then((response) => {
                            if (
                                response.data.result == "emailExists" ||
                                response.data.result == "0"
                            ) {
                                return this.$swal({
                                    icon: "warning",
                                    html: `Email already exists. If you forgot your password <a href='/auth/forgot-password'>Click here</a>`,
                                    focusConfirm: false,
                                    showCloseButton: true,
                                    showConfirmButton: false,
                                });
                            }
                            this.$router.replace({ name: "auth-login" });
                            this.$swal({
                                icon: "success",
                                title: "Register success",
                                text: "WR1 team is processing customer information. Please follow email or contact WR1 team directly with hotline (+84) 964 671 674!",
                            });
                        })
                        .catch((error) => {
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title:
                                        error.response?.data?.message ||
                                        "Lỗi hệ thống",
                                    icon: "AlertTriangleIcon",
                                    variant: "danger",
                                },
                            });
                        });
                }
            });
        },

        hideShowsi: function () {
            this.isHideShow = !this.isHideShow;
        },
        hideShowsPk: function () {
            this.isHideShowPk = !this.isHideShowPk;
        },

        sendRequest() {},
        formatOption(arr) {
            const mapData = arr.map((obj) => {
                obj.text = obj.text || obj.name;
                obj.id = obj.code;
                return obj;
            });
            return mapData;
        },
        async sendRequestQuotation() {
            var validate = await this.$refs.requestQuotationRules
                .validate()
                .then((success) => {
                    return success;
                });
            if (!validate) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.$i18n.t("notifyFormError"),
                        icon: "AlertTriangleIcon",
                        variant: "warning",
                    },
                });
                return;
            }

            this.$bvModal.show("modal-regiter");
        },
        removeFile(file, error, xhr) {
            if (file && file.xhr !== undefined) {
                const xhrJson = JSON.parse(file.xhr.response);
                const path = xhrJson.result.path;
                const bookingId = "-1";
                this.$store.dispatch("attachFile/deleteFile", {
                    bookingId,
                    path,
                });
            }
        },
        vdropzoneError(file, errorMessage) {
            this.$refs.myVueDropzone.removeFile(file);
            if (errorMessage.includes("Max filesize: 10MiB")) {
                return this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.$i18n.t("uploadSizeErrorFile"),
                        icon: "AlertTriangleIcon",
                        variant: "danger",
                    },
                });
            }

            if (errorMessage.includes("You can not upload any more files.")) {
                return this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.$i18n.t("uploadLimitErrorFile"),
                        icon: "AlertTriangleIcon",
                        variant: "danger",
                    },
                });
            }
        },
    },
};
</script>
